import React, { useState, createContext } from 'react'

export const PlansTrendsContext = createContext({})

export function PlansTrendsProvider({ children }) {
  const [showHighlights, setShowHighlights] = useState(false);

  function showHighlightsPrices() {
    setShowHighlights(state => !state)
  }
  const value = {
    showHighlights,
    showHighlightsPrices

  }

  return (
    <PlansTrendsContext.Provider value={value}>
      {children}
    </PlansTrendsContext.Provider>
  )
}
